import EmaButton from "components/emaButton/EmaButton";
import "./AuthFailure.sass";
import { getRedirectURIOrigin } from "services/Auth";
import { inValidateCookies } from "services/cookies";

const reload = () => {
  inValidateCookies(true);
  window.location.reload();
};
const AuthFailure = ({ message }) => {
  window.history.replaceState({}, "", getRedirectURIOrigin());
  message = message || "Sorry, your login attempt was not successful.";
  return (
    <div className="auth-failure">
      <div className="auth-failure-content">
        <h4 className="auth-failure-message">{message}</h4>
        <EmaButton title="Refresh" btnDark onClick={reload} />
      </div>
    </div>
  );
};

export default AuthFailure;
